RivalIQ.apps.Insights.module('widgets', function (widgets, App, Backbone, Marionette, $, _, s, d3, moment) {

    'use strict';

    const postDetailsByChannel = function (channel) {
        if (channel === RivalIQ.enums.sourceDetails[RivalIQ.enums.sources.FACEBOOK].channel) {
            return App.data.getFacebookInsightsPostMetrics();
        } else if (channel === RivalIQ.enums.sourceDetails[RivalIQ.enums.sources.LINKEDIN].channel) {
            return App.data.getLinkedInInsightsPostMetrics();
        }
    };

    function createPublished(date) {

        const publishedAt = moment.utc(date);

        return [
            $.tagHtml('strong', {
                text: publishedAt.format('MMM D, YYYY')
            }),
            $.tagHtml('span', {
                class: 'text-muted',
                text: publishedAt.format('LT')
            }),
            $.tagHtml('span', {
                class: 'text-muted',
                text: 'UTC'
            })
        ].join('');
    }

    function createEngagementRate(engagementRate, post) {
        return RivalIQ.formatter.naFalsyDataWrapper(RivalIQ.formatter.formatPercentage)(post.insights_engagement_rate);
    }

    function getMetricLabel(name, value) {
        return $.tagHtml('div', {
            class: ['widget-insights-summary-tooltip', 'columnar', 'clearfix'],
            html: [
                $.tagHtml('div', {
                    class: 'pull-left',
                    html: [
                        $.tagHtml('p', {
                            class: 'metric-label',
                            text: name
                        }),
                        $.tagHtml('h1', {
                            class: 'metric-value',
                            text: value
                        })
                    ].join('')
                })
            ].join('')
        });
    }

    // InsightsPostsDataGenerator only uses name and property, trim away the extra fluff.
    function prepareExportColumnsForCSV(exportColumns) {
        return _.map(exportColumns, function (exportColumn) {
            if (exportColumn instanceof Backbone.Model) {
                return _.pick(exportColumn.attributes, 'name', 'property');
            } else {
                return _.pick(exportColumn, 'name', 'property');
            }
        });
    }

    // exposed for testing
    widgets._PostView = Marionette.ItemView.extend({
        events: {
            'click a': 'onViewLinkClicked'
        },

        ui: {
            popover: `[data-toggle='popover']`,
            tooltip: `[data-toggle='tooltip']`
        },

        className: 'post',
        template: '#widgetInsightsPostTemplate',

        templateHelpers: function () {

            return _.extend({
                boostedPostPopoverTemplate: Marionette.TemplateCache.get('#tableCellTooltip'),
                s: s
            }, RivalIQ.utils.emoji.getTemplateHelpers());
        },

        serializeData: function () {
            const me = this;
            const postJson = me.model.toJSON();

            const message = postJson.message || postJson.linkTitle || postJson.linkDescription;

            return _.extend({
                image: null
            }, postJson, {
                message: message,
                abbreviated_type: postJson.abbreviated_type || postJson.type
            });
        },

        onRender: function () {
            const me = this;
            me.ui.tooltip.tooltip();
            me.ui.popover.popover({
                html: true
            });
        },

        onViewLinkClicked: function (e) {

            e.stopPropagation();
        }
    });

    function createPost(post) {

        const getDisplay = function (post) {
            const displayModel = _.get(post, 'rivaliq.display');
            displayModel.channelName = RivalIQ.enums.sourceDetails[post.source].name;
            displayModel.isRestricted = post.is_restricted;

            const boostedPosts = RivalIQ.state.account.channelDisplay(RivalIQ.enums.sourceMask.FACEBOOK_BOOSTED_POST_INSIGHTS);
            if (boostedPosts) {
                displayModel.boosted_post_total_spend = post.boosted_post_total_spend;
            } else {
                displayModel.boosted_post_total_spend = null;
            }

            // These two fields are used by the broken post image mixin.
            displayModel.source = post.source;
            displayModel.id = [post.source, post.id].join('.');
            displayModel.abbreviated_type = _.get(post, ['rivaliq', 'only_display', 'abbreviated_type']);

            return displayModel;
        };

        return new widgets._PostView({
            model: new Backbone.Model(getDisplay(post) || {})
        });
    }

    // valueOverride is an array of equal length to concepts. it enables an override of the value that labels the
    // bar to be explicitly specified by a different concept. you can pass null for any position of the valueOverride
    // that you don't want to override.
    // an example of the usage of value override is Total Reach. These are unique values, but Facebook doesn't
    // de-dupe organic from viral s.t. the sum of the organic + viral + paid reach != total_impressions_unique
    function createBars(concepts, posts, tooltip, labelValueOverride, options) {

        function getValue(post, concept) {
            if (_.isArray(concept.property)) {
                return _.reduce(concept.property, function (acc, property) {
                    return acc + _.get(post, property);
                }, 0);
            } else {
                return _.get(post, concept.property);
            }
        }

        const max = _.reduce(posts, function (memo, post) {

            return _.reduce(concepts, function getMax(memo, concept) {

                let value = memo;

                if (_.isArray(concept)) {

                    value = _.reduce(concept, function (total, subconcept) {

                        return total + getValue(post, subconcept);
                    }, 0);
                } else {

                    value = getValue(post, concept);
                }

                return (value > memo ? value : memo);
            }, memo);
        }, -Infinity);

        const omitNullBars = _.get(options, ['omitNullBars'], false);
        const omitNullValues = _.get(options, ['omitNullValues'], false);

        return function (aggregate, post) {
            const rows = _.map(concepts, function (concept, conceptCount) {

                let bars = null;
                let value = null;
                let divisor = max;

                const toPercent = function (f) {

                    return `${f * 100}%`;
                };

                if (_.isArray(concept)) {

                    divisor = value = _.reduce(concept, function (memo, subconcept) {

                        return memo + getValue(post, subconcept);
                    }, 0);

                    bars = _.map(concept, function (subconcept) {
                        const value = getValue(post, subconcept);
                        if (value > 0) {
                            return $.tagHtml('div', {
                                class: subconcept.className,
                                html: '&nbsp;',
                                width: toPercent(value / divisor)
                            });
                        } else {
                            return '';
                        }
                    }).join('');
                } else {

                    value = getValue(post, concept);
                    if (omitNullValues && !_.isFinite(value)) {
                        return '';
                    } else if (omitNullBars && !_.isFinite(value)) {
                        bars = '';
                    } else {
                        bars = $.tagHtml('div', {
                            class: concept.className,
                            html: '&nbsp;',
                            width: toPercent(1)
                        });
                    }
                }
                // to handle the labelValueOverride case, store the display value separately
                let displayValue = value;
                if (labelValueOverride && labelValueOverride[conceptCount]) {
                    displayValue = getValue(post, labelValueOverride[conceptCount]);
                }
                displayValue = abbreviatedFormatter(displayValue);

                return $.tagHtml('tr', {
                    html: [
                        $.tagHtml('td', {
                            text: displayValue
                        }),
                        $.tagHtml('td', {
                            html: $.tagHtml('div', {
                                class: 'bar',
                                'data-toggle': 'popover',
                                'data-trigger': 'hover',
                                'data-placement': 'auto top',
                                'data-html': true,
                                'data-content': tooltip(post, displayValue, concept),
                                width: toPercent(value / max),
                                html: bars
                            })
                        })
                    ].join('')
                });
            }).join('');

            return $.tagHtml('table', {
                html: rows
            });
        };
    }

    function getReachTooltip(post, aggregate, concepts) {

        const items = _.map(concepts, function (concept, i) {
            const name = (i < 1 ?
                App.enums.reach.organic :
                (i < 2 ? App.enums.reach.viral : App.enums.reach.paid));

            const property = _.get(concept, 'property');
            const value = _.get(post, property);
            const formatter = _.get(concept, 'format', RivalIQ.formatter.formats.number);

            return {
                name: name,
                className: name.toLowerCase(),
                value: formatter(value)
            };
        });

        const summary = new RivalIQ.apps.Dashboard.widgets.MetricSummaryTooltip({
            model: new RivalIQ.models.MetricDefinition({
                value: aggregate,
                name: 'Total Reach'
            }),
            collection: new RivalIQ.collections.MetricDefinitions(items),
            companyId: post.company_id
        }).render().el.outerHTML;

        return summary;
    }

    const Submetric = Marionette.ItemView.extend({
        ui: {
            label: '.name-label',
            checkbox: 'input[type=checkbox]'
        },

        eventsNotToDebounce: {
            'click @ui.label': 'onLabelClicked',
            'change @ui.checkbox': 'onCheckboxChanged'
        },

        behaviors: {
            Information: {
                behaviorClass: RivalIQ.behaviors.Information,
                placement: 'auto right'
            }
        },

        tagName: 'tr',
        template: '#widgetInsightsSubmetricTemplate',

        serializeData: function () {

            const me = this;
            const data = me.model.toJSON();
            const post = me.getOption('post');

            if (!post) {

                return data;
            }

            if (_.has(data, 'property')) {

                data.value = _.get(post, data.property);
            }

            if (_.isFunction(data.value)) {

                data.value = data.value(post);
            }

            if (_.has(data, 'default') && _.isUndefined(data.value) || _.isNull(data.value)) {

                data.value = data.default;
            }

            if (_.isFunction(data.formatter)) {
                data.value = data.formatter(data.value, post);
            } else if (_.isFinite(data.value)) {

                data.value = RivalIQ.formatter.formats.abbreviated(data.value);
            }

            return data;
        },

        onRender: function () {

            const me = this;
            const columns = me.getOption('columns');

            if (columns) {

                const columnModel = columns.get(me.model.id);

                if (columnModel) {
                    const checked = !columnModel.get('omit');

                    me.ui.checkbox.prop('checked', checked);

                    if (checked) {

                        me.ui.label.addClass('enabled');
                    } else {

                        me.ui.label.removeClass('enabled');
                    }
                }
            }
        },

        onLabelClicked: function (e) {

            const me = this;
            const checkbox = me.ui.checkbox;

            if (checkbox) {

                e.stopPropagation();
                checkbox.prop('checked', !checkbox.is(':checked')).trigger('change');
            }
        },

        onCheckboxChanged: function (e) {

            const me = this;
            const checked = me.ui.checkbox.is(':checked');

            e.stopPropagation();

            if (checked) {

                me.ui.label.addClass('enabled');
            } else {

                me.ui.label.removeClass('enabled');
            }

            me.triggerMethod('metric:change', {
                id: me.model.id,
                omit: !checked
            });
        }
    });

    const Metric = Marionette.CompositeView.extend({
        ui: {
            label: '.name-label',
            checkbox: 'input[type=checkbox]'
        },
        className: 'metric-row clearfix',

        eventsNotToDebounce: {
            'click @ui.label': 'onLabelClicked',
            'change @ui.checkbox': 'onCheckboxChanged'
        },

        behaviors: {
            Information: {
                behaviorClass: RivalIQ.behaviors.Information,
                placement: 'auto right'
            }
        },

        childView: Submetric,
        childViewContainer: 'tbody',
        childViewOptions: function () {

            const me = this;
            const post = me.getOption('post');

            if (!post) {

                return {
                    columns: me.getOption('columns'),
                    template: '#widgetInsightsSubcolumnTemplate'
                };
            }

            return {
                post: me.getOption('post')
            };
        },

        template: '#widgetInsightsMetricTemplate',

        initialize: function () {

            const me = this;
            const model = me.model;
            me.collection = new Backbone.Collection(model.get('items') || []);
        },

        onRender: Submetric.prototype.onRender,
        serializeData: Submetric.prototype.serializeData,
        onLabelClicked: Submetric.prototype.onLabelClicked,
        onCheckboxChanged: Submetric.prototype.onCheckboxChanged
    });

    const MetricsParent = {
        getChildView: function (model) {
            if (model.has('items')) {
                return Metric;
            } else {
                return Marionette.CollectionView.mixin({
                    className: 'row',

                    mixins: {
                        metricsParent: MetricsParent
                    }
                });
            }
        },

        childViewOptions: function (model) {

            const me = this;
            const options = {
                post: me.getOption('post')
            };

            if (!model.has('items')) {

                _.extend(options, {
                    nested: true,
                    className: 'col-md-12 col-sm-12 col-xs-12',
                    childViewOptions: {
                        post: me.getOption('post'),
                        className: 'col-md-6 col-sm-6 col-xs-6'
                    },
                    collection: new Backbone.Collection(_.values(model.toJSON()))
                });

                if (!options.post) {

                    _.extend(options.childViewOptions, {
                        columns: me.getOption('columns'),
                        template: '#widgetInsightsColumnTemplate'
                    });
                }
            }

            if (!options.post) {

                _.extend(options, {
                    columns: me.getOption('columns'),
                    template: '#widgetInsightsColumnTemplate'
                });
            }

            return options;
        }
    };

    const MetricsGroup = Marionette.CompositeView.mixin({
        template: '#widgetInsightsColumnGroupTemplate',
        className: 'metric-row clearfix',
        mixins: {
            metricsParent: MetricsParent
        },

        serializeData: function () {
            const me = this;
            const model = me.model;

            return _.extend({
                showCategoryName: me.getOption('showCategoryName')
            }, (model ? model.toJSON() : {}));
        }
    });

    const Columns = widgets.Columns = Marionette.LayoutView.extend({
        regions: {
            metrics: '.metrics-region.general',
            postTypeMetrics: '.post-type'
        },

        className: 'container-fluid',

        template: '#widgetInsightsColumnModalTemplate',

        // this is true for the column picker, but not the post modal (both of which use this view)
        useMultipleColumnLayout: true,

        hasMultipleMetricColumns: function () {
            const me = this;

            const columnIndexes = _.uniq(me.collection.map(function (metricGroup) {
                return metricGroup.get('columnIdx');
            }));
            return (columnIndexes.length > 1);
        },

        serializeData: function () {

            const me = this;
            const model = me.model;

            return _.extend({
                hasMultipleMetricColumns: me.hasMultipleMetricColumns()
            }, (model ? model.toJSON() : {}));
        },

        onBeforeShow: function () {

            const me = this;
            const collection = me.collection;

            // this layout could be more fluid, but there's no use-case for N columns
            if (me.useMultipleColumnLayout && me.hasMultipleMetricColumns()) {
                const showCategoryName = (me.getOption('channel') === RivalIQ.enums.channels.FACEBOOK);
                me.showMetrics(collection, me.postTypeMetrics, 0, showCategoryName);
                me.showMetrics(collection, me.metrics, 1, showCategoryName);
            } else {
                me.showMetrics(collection, me.metrics, 0, false);
            }
        },

        showMetrics: function (metricsGroups, region, columnIdx, showCategoryName) {

            const me = this;
            const model = me.model;

            if (!metricsGroups || !metricsGroups.length) {

                return;
            }

            const metricsGroupsView = new Marionette.CollectionView({
                className: 'row',
                childView: MetricsGroup,
                collection: metricsGroups,
                filter: function (metricGroup) {
                    return !me.useMultipleColumnLayout || metricGroup.get('columnIdx') === columnIdx;
                },
                childViewOptions: function (metricGroup) {
                    return {
                        collection: metricGroup.metricCollection,
                        columns: me.getOption('columns'),
                        post: (model ? model.toJSON() : null),
                        showCategoryName: showCategoryName
                    };
                }
            });

            const onMetricChange = function () {

                me.triggerMethod('column:change', _.last(arguments));
            };

            // TODO: come on now.
            me.listenTo(metricsGroupsView, 'childview:metric:change', onMetricChange);
            me.listenTo(metricsGroupsView, 'childview:childview:metric:change', onMetricChange);
            me.listenTo(metricsGroupsView, 'childview:childview:childview:metric:change', onMetricChange);
            me.listenTo(metricsGroupsView, 'childview:childview:childview:childview:metric:change', onMetricChange);

            region.show(metricsGroupsView);
        }
    });

    const Modal = Columns.extend({

        useMultipleColumnLayout: false,

        regions: function () {

            return _.extend({
                post: '.post-region'
            }, widgets.Columns.prototype.regions);
        },

        template: '#widgetInsightsPostModalTemplate',

        onBeforeShow: function () {

            const me = this;
            me.showPost();
            widgets.Columns.prototype.onBeforeShow.apply(me, arguments);
        },

        showPost: function () {

            const me = this;
            const model = me.model;

            model.set('engagement_rate', model.get('insights_engagement_rate') || 0);

            const channel = me.getOption('channel');
            const presencePeriodSummary = me.getOption('presencePeriodSummary');

            const View = App.views.ContentListItem.getViewClassByChannelType(
                channel, model.get('type'));

            const view = new View({
                index: 1,
                model: model,
                channel: channel,
                companyData: presencePeriodSummary
            });

            me.post.show(view);
        },

        getMetricTypes: function () {

            const me = this;
            const post = me.model;
            return (!post.isType('video') || post.isNativeVideo() ? [post.get('type')] : []);
        }
    });

    function abbreviatedFormatter(val) {

        if (_.isFinite(val) && val < 100) {

            return val;
        }

        return RivalIQ.formatter.naFalsyDataWrapper(RivalIQ.formatter.formatAbbreviated)(val, ',');
    }

    function getEngagementTooltip(post, aggregate, concept) {

        let name = RivalIQ.strings.facebook_insights_posts_legend_clicks;
        if (concept.property === 'engagement_total') {
            name = RivalIQ.strings.facebook_insights_posts_legend_engagement;
        }

        return getMetricLabel(name, abbreviatedFormatter(aggregate));
    }

    const Posts = widgets.Posts = RivalIQ.views.LayoutView.mixin({
        regions: {
            posts: '.posts-region'
        },

        mixins: {
            props: Marionette.Dashboard.mixins.Props,
            brokenThumbnailHandler: RivalIQ.utils.BrokenThumbnailHandler
        },

        dashboardModelEvents: {
            'change:filter': 'reload',
            'change:timePeriod': 'reload',
            'change:columns': 'onColumnsChanged',
            'change:companyId': 'onCompanyIdChanged'
        },

        className: 'widget-insights-posts',
        template: '#widgetInsightsPostsTemplate',

        initialize: function () {
            const me = this;

            me.activeSort = me.getProp('sort');
            me.activeSortOrder = me.getProp('sortOrder');

            const optionalColumns = me.getOptionalColumns();
            if (_.size(optionalColumns)) {
                me.listenTo(optionalColumns, 'change:omit', _.debounce(function () {
                    me.setProps('columns', optionalColumns.getActiveIds(), {
                        navigate: false
                    });
                }, {
                    trailing: true
                }));
            }

            me.updateHeader();
        },

        loadData: function () {
            const me = this;
            const props = me.getProps();

            return $.when(RivalIQ.data.companyData.fetch(props), App.data.Posts.fetch(props))
                .fail(_.bind(me.trigger, me, 'widget:error'))
                .done(function (presencePeriodSummary, collection) {
                    me.presencePeriodSummary = presencePeriodSummary;
                    me.collection = collection;
                });
        },

        onRenderLoaded: function () {

            const me = this;

            me.showPosts();
        },

        updateHeader: function () {

            const me = this;
            const limit = me.getProp('limit');
            const detailsTitle = me.getProp('detailsTitle');

            if (!isNaN(limit) || !detailsTitle) {

                return;
            }

            me.setTitle(detailsTitle);
        },

        getColumns: function (data) {
            const me = this;

            let defaultColumns = me.dashboardModel.getDefaultColumns(data);

            defaultColumns = defaultColumns || [
                {
                    name: 'Published',
                    property: 'published_at',
                    sort: 'published_at',
                    className: 'post-published',
                    cellClassName: 'published',
                    formatter: createPublished
                },
                {
                    name: 'Post',
                    value: createPost,
                    cellClassName: 'post',
                    className: 'post-content-header'
                }
            ];

            const optionalColumns = me.getOptionalColumns().toJSON();
            const pickedColumns = _.filter(optionalColumns, function (column) {
                return _.includes(me.getProp('columns'), column.id);
            });

            // NOTE hack for old style table formatter
            _.each(pickedColumns, function (column) {
                column.formatter = column.valueFormat || column.formatter;
            });

            const allColumns = defaultColumns.concat(pickedColumns);
            // linkedin eng total / eng rate `li_insights_engagement` and `li_insights_engagement_rate`.
            // Default columns are `insights_engagement` and `insights_engagement_rate`.
            // strip `li_` to make sure there are no duplicate columns.
            return _.uniqBy(allColumns, function (metric) {
                if (metric.property) {
                    return metric.property.replace('li_', '');
                }
            });
        },

        createTableData: function () {
            const me = this;

            return me.collection.reduce(function (memo, post) {
                const json = post.toJSON();

                return memo.concat(
                    _.extend(json, post.calculateEngagement())
                );
            }, []);
        },


        createTableColumnsFromData: function (data) {
            const me = this;
            const limit = parseInt(me.getProp('limit'));

            const columns = me.getColumns(data);

            if (!isNaN(limit)) {

                _.each(columns, function (column) {

                    delete column.sort;
                });
            }

            // Add an onSort function to each column that triggers a reload from the server (to use server side sorting/limiting),
            _.each(columns, function (column) {

                if (!column.sort) {
                    return;
                }

                const sort = column.sort;
                const key = (column.sortKey || column.property);

                column.onSort = function insights_widgets_post_column_onSort() {

                    // the scope here is actually the TableContainer
                    const me = this;
                    const order = (me.activeSort === key ? me.activeSortOrder * -1 : -1);

                    const event = {
                        sort: sort,
                        sortOrder: order,
                        sortProperty: key
                    };

                    me.trigger('change:option', event);
                    me.triggerMethod('sort', key, order);

                    RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.SortedInsightsPostDetails, {
                        order: order,
                        property: key
                    });
                };
            });

            return columns;

        },


        showPosts: function () {

            const me = this;

            const limit = parseInt(me.getProp('limit'));
            const presencePeriodSummary = me.presencePeriodSummary;

            const data = me.createTableData();
            const columns = me.createTableColumnsFromData(data);

            const view = new RivalIQ.views.TableContainer({
                config: {
                    className: 'table',
                    limit: limit,
                    columns: columns,
                    activeSort: me.getProp('sort'),
                    activeSortOrder: me.getProp('sortOrder'),
                    onRowClick: _.bind(me.onPostClicked, me, presencePeriodSummary),
                    sortUsageMetric: RivalIQ.tracking.metric.SortedInsightsPostDetails
                },
                tableResponsive: !me.dashboardModel.isExporting(),
                model: new Backbone.Model({
                    data: data
                })
            });

            const initializePopovers = function () {

                view.$('[data-toggle="popover"]').popover();
            };

            me.listenTo(view, 'show', initializePopovers);
            me.listenTo(view, 'sort', initializePopovers);

            me.listenTo(view, 'change:option', function (event) {
                me.setProps('sort', event.sortProperty);
                me.setProps('sortOrder', event.sortOrder);

                me.collection.sort = event.sortProperty;
                me.collection.sortOrder = event.sortOrder;

                me.reload();
            });

            me.posts.show(view);
        },

        onPostClicked: function (presencePeriodSummary, post) {
            const me = this;
            const channel = me.getProp('channel');

            // navigate to the details page for Facebook posts
            if (channel === RivalIQ.enums.channels.FACEBOOK) {
                const router = me.dashboardModel.curation.router;

                const detailsProps = {
                    companyId: me.getProp('companyId'),
                    postId: post.id
                };

                if (me.dashboardModel.isFocus()) {
                    detailsProps.from = me.getProp('instanceId');
                    detailsProps.fromProps = _.pick(me.getProps(), 'sort', 'sortOrder', 'filter');
                }

                const path = router.resolveCurationRoute(RivalIQ.enums.curation.FACEBOOK_INSIGHTS_POST_DETAILS, detailsProps);

                return RivalIQ.execute('history:navigate', path, {
                    trigger: true
                });
            }


            const view = new Modal({
                channel: channel,
                model: new App.models.Post(post),
                presencePeriodSummary: presencePeriodSummary,
                collection: postDetailsByChannel(channel).getForType(post.type),
                dashboardModel: me.dashboardModel
            });

            const modalTitle = `${me.dashboardModel.postName} Details`;
            const modalContent = `The detailed metrics for the ${me.dashboardModel.postName.toLowerCase()} you selected.`;

            RivalIQ.execute('show:modal', {
                size: 'large',
                contentView: view,
                className: 'post-modal',
                information: {
                    title: modalTitle,
                    content: modalContent
                },
                tracking: {
                    metric: RivalIQ.tracking.metric.ViewedInsightsPostModal,
                    options: {
                        channel: channel
                    }
                }
            });
        },

        onColumnsChanged: function () {
            const me = this;
            // NOTE we use `_.defer` here to allow the modal to close before
            // an attempt to reload occurs (otherwise we run the risk of
            // blocking the UI when we have cached data and immediately start
            // rendering). we don't use `requestAnimationFrame` here either
            // because we don't want to wait that long (only until whatever
            // is on the call stack is complete).
            _.defer(function () {
                me.reload();
            });
        },

        onCompanyIdChanged: function (curation) {

            const me = this;
            const companyId = me.companyId = me.options.companyId = curation.get('companyId');
            me.triggerMethod('change:option', {
                companyId: companyId
            });
            me.reload();
        },

        getOptionalColumns: function () {

            const me = this;

            const channel = me.getProp('channel');
            return postDetailsByChannel(channel).getColumns();
        }
    });

    Posts.manageToolbarAction = function (options) {

        const postName = options.postName || 'Post';
        const channel = options.channel;
        const postMetrics = postDetailsByChannel(channel);

        // NOTE we have to grab this here because it depends on state
        const columnLookup = postMetrics.getColumns();

        const view = new Columns({
            columns: columnLookup,
            collection: postMetrics,
            channel: channel
        });

        const columns = new Backbone.Collection(columnLookup.toJSON());

        view.listenTo(view, 'column:change', function (column) {

            columns.add(column, {
                merge: true
            });
        });

        const infoContent = `Choose which columns appear in your ${postName} panel.`;

        RivalIQ.execute('show:modal', {
            size: 'large',
            information: {
                title: 'Manage Columns',
                content: infoContent
            },
            className: 'post-modal post-columns',
            contentView: view,
            tracking: {
                metric: RivalIQ.tracking.metric.ViewedInsightsManageColumnsModal,
                options: {
                    channel: channel
                }
            },
            actions: [
                {
                    type: 'close'
                },
                {
                    state: columns,
                    stateEvents: {
                        all: function () {

                            const me = this;
                            me.$el.attr(_.result(me, 'attributes'));
                        }
                    },
                    events: {
                        click: function () {

                            _.defer(function () {
                                columnLookup.add(columns.toArray(), {
                                    merge: true
                                });
                                RivalIQ.state.landscape.set({
                                    columns: columnLookup.toSettings()
                                });
                            });
                        }
                    },
                    html: 'Save changes',
                    className: 'btn btn-primary',
                    attributes: function () {

                        return {
                            type: 'button',
                            'data-dismiss': 'modal'
                        };
                    }
                }
            ]
        });
    };

    const ManageColumnsBtn = RivalIQ.views.Link.mixin({
        linkName: 'Manage Columns...',
        className: 'btn btn-default btn-xs',

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        action: function () {
            const me = this;

            Posts.manageToolbarAction(me.getProps());
        }
    });

    const PostPanel = RivalIQ.apps.Dashboard.views.Panel.extend({
        className: 'panel panel-default widget-insights-posts',
        showActions: function () {
            const me = this;

            me.actions.show(new ManageColumnsBtn({
                dashboardModel: me.dashboardModel
            }));

            if (!me.dashboardModel.isFocus()) {
                me.showExportDropdown();
            }
        }
    });

    const PostPanelFooter = RivalIQ.apps.Dashboard.views.PanelFooter.extend({
        template: '#insightsPostPanelFooterTemplate',

        templateHelpers: function () {
            const me = this;

            const templateAttributes = RivalIQ.apps.Dashboard.views.PanelFooter.prototype.templateHelpers.call(me);

            const legendValues = me.dashboardModel.getLegendValues();

            return _.extend(templateAttributes, {
                legendValues: legendValues
            });
        }
    });

    const PostDetailPanel = RivalIQ.apps.Dashboard.views.DetailsLayout.extend({

        className: 'widget-insights-posts',

        showActions: function () {
            const me = this;

            me.actions.show(new ManageColumnsBtn({
                dashboardModel: me.dashboardModel
            }));
        },

        showToolbarActions: function () {
            const me = this;

            const hidePostFilter = Boolean(me.getProp('hidePostFilter'));
            if (!hidePostFilter) {
                me.leftActions.show(new App.views.PostTypeFilter({
                    dashboardModel: me.dashboardModel
                }), {
                    preventDestroy: true
                });
            }

            me.actions.show(new RivalIQ.apps.Dashboard.views.ExportDropdown({
                model: me.dashboardModel
            }), {
                preventDestroy: true
            });
        }
    });

    // Note: This is ADDITIONAL columns. Total column count is 4 + MAX_EXPORT_COLUMNS.
    const MAX_EXPORT_COLUMNS = 1;
    const InsightsPostsWidget = RivalIQ.apps.Dashboard.models.Widget.mixin({

        mixins: {
            InsightsExportTitle: App.widgets.InsightsExportTitle
        },

        getDefaultColumns: function () {
            return [];
        },

        getLegendValues: _.constant([]),

        hasFooter: _.constant(true), // all views and exports show a legend

        view: Posts,
        panelView: PostPanel,
        detailPanelView: PostPanel,
        getDetailWrapperView: _.constant(PostDetailPanel),
        footerView: PostPanelFooter,
        scheduledExportAdvancedSettingsEnabled: false,

        exportFormats: [
            RivalIQ.enums.exportFormat.PDF,
            RivalIQ.enums.exportFormat.PPT,
            RivalIQ.enums.exportFormat.PNG,
            RivalIQ.enums.exportFormat.CSV
        ],

        getPropsForSchedule: function (format) {
            const me = this;
            const props = _.omit(me.getPropsForFormat(format), ['format'].concat(me.stateProps));

            // See #13927. When we're generating the report schedule, we don't need to serialize
            // all of the metrics. We'll actually setup the exportColumns at report run time.
            if (format === RivalIQ.enums.exportFormat.CSV) {
                delete props.exportColumns;
            }

            return props;
        },

        csvExportProps: function (props) {
            const me = this;

            const exportColumns = RivalIQ.apps.Insights.utils.getDefaultPostColumns().concat(
                RivalIQ.apps.Insights.data.getFacebookInsightsPostMetrics().getColumns().toArray());

            return _.defaults({
                type: 'fb_insights_posts',
                exportColumns: prepareExportColumnsForCSV(exportColumns),
                companyId: me.getProp('companyId'),
                postTypeFilter: me.getProp('filter'),
                timePeriod: me.getProp('timePeriod')
            }, props);
        },

        // be sure to limit the columns on full page export too
        getPropsForCurationExport: function () {
            const me = this;
            return me.exportProps(me.getProps());
        },

        exportProps: function (props) {
            const me = this;
            const columns = props.columns;

            const channelColumns = postDetailsByChannel(props.channel).getColumns();
            const sortColumn = channelColumns.find({
                property: props.sort
            });
            const sortMetricId = _.get(sortColumn, 'id');
            const sortIndex = _.indexOf(columns, sortMetricId);

            if (_.size(props.columns) > MAX_EXPORT_COLUMNS) {

                props.columns = _.take(props.columns, MAX_EXPORT_COLUMNS);

                // if we didn't include the sort column, add it to the end
                if (sortIndex >= MAX_EXPORT_COLUMNS) {
                    props.columns.pop();
                    props.columns.push(columns[sortIndex]);
                }
            }

            return me.mixins.Export.exportProps.call(me, props);
        },

        getFilename: function () {
            const me = this;

            return RivalIQ.export.filename.base({
                title: _.snakeCase(me.title.toLowerCase()),
                landscapeName: RivalIQ.state.view.get('landscapeName'),
                companyId: me.getProp('companyId')
            });
        },
        propsToSerializeForExport: [
            'channel',
            'sort',
            'sortOrder',
            'limit',
            'filter',
            'columns'
        ]
    });

    const FbInsightsPostsWidget = InsightsPostsWidget.extend({

        title: RivalIQ.strings.fb_insights_posts_title,
        description: function () {
            const me = this;
            return (me.isFocus() ? RivalIQ.strings.fb_insights_posts_info : RivalIQ.strings.fb_insights_posts_mini_info);
        },

        postName: 'Post',

        getExportSubtitle: function () {
            const me = this;
            if (me.isFocus()) {
                const subTitleParts = [];

                const timezone = RivalIQ.state.landscape.get('timezone');
                subTitleParts.push(RivalIQ.utils.timePeriod.getTimePeriodDisplayString(me.getProp('timePeriod'), true, timezone));

                const postTypeFilter = me.getProp('filter');
                if (postTypeFilter) {
                    subTitleParts.push(`Post Type "${s.capitalize(postTypeFilter)}"`);
                }

                return subTitleParts.join(', ');
            }
        },

        getDefaultColumns: function (data) {
            return [
                {
                    name: 'Published',
                    property: 'published_at',
                    sort: 'published_at',
                    // NOTE: if you don't set a width on this column, you'll get odd export behavior. See #3532
                    className: 'post-published col-sm-1',
                    cellClassName: 'published',
                    formatter: createPublished
                },
                {
                    name: 'Post',
                    value: createPost,
                    cellClassName: 'post',
                    className: 'post-content-header'
                },
                // note that we pass a labelValueOverride to createBars here since the sum of these three metrics
                // actually can be greater than the actual unique reach (since FB double counts some viral impressions)
                {
                    name: 'Total Reach',
                    property: 'facebook_insights_data.post_impressions_unique',
                    sort: 'facebook_insights_data.post_impressions_unique',
                    cellClassName: 'bars reach',
                    className: 'post-reach-header',
                    formatter: createBars([[
                        {
                            property: 'facebook_insights_data.post_impressions_organic_unique',
                            className: 'organic'
                        },
                        {
                            property: 'facebook_insights_data.post_impressions_viral_unique',
                            className: 'viral'
                        },
                        {
                            property: 'facebook_insights_data.post_impressions_paid_unique',
                            className: 'paid'
                        }
                    ]], data, getReachTooltip, [{
                        property: 'facebook_insights_data.post_impressions_unique'
                    }])
                },
                {
                    name: 'Engagement',
                    property: 'insights_engagement',
                    sort: 'insights_engagement',
                    className: 'post-engagement-header',
                    cellClassName: 'bars engagement',
                    formatter: createBars([
                        {
                            property: 'facebook_insights_data.post_consumptions',
                            className: 'post-clicks'
                        },
                        {
                            property: 'engagement_total',
                            className: 'likes-comments-shares'
                        }
                    ], data, getEngagementTooltip)
                }
            ];
        },

        getLegendValues: _.constant(
            [
                {
                    name: 'Organic',
                    className: 'organic'
                },
                {
                    name: 'Viral',
                    className: 'viral'
                },
                {
                    name: 'Paid',
                    className: 'paid'
                },
                {
                    name: RivalIQ.strings.facebook_insights_posts_legend_clicks,
                    className: 'post-clicks'
                },
                {
                    name: RivalIQ.strings.facebook_insights_posts_legend_engagement,
                    className: 'likes-comments-shares'
                }
            ]
        ),

        // remove columns that you no longer have access to. E.g., if you had ads access then downgraded.
        removeRevokedMetrics: function (props) {
            const validColumns = postDetailsByChannel(props.channel).getColumns();

            props.columns = _.filter(props.columns, function (metricId) {
                return Boolean(validColumns.get(metricId));
            });
        },

        processProps: function (props) {
            const me = this;

            _.defaults(props, {
                sortOrder: -1,
                sort: 'insights_engagement',
                filter: null,
                // If columns were not passed in, construct them from rivaliq state
                columns: postDetailsByChannel(props.channel).getColumns().getActiveIds(),
                defaultColumns: me.getDefaultColumns
            });

            me.removeRevokedMetrics(props);

            if (!props.instanceId) {
                // only show 3 by default outside of details mode.
                _.defaults(props, {
                    limit: 3
                });
            }

            return props;
        },

        processExportProps: function (props, changed) {
            const me = this;

            props = me.processProps(props, changed);

            // NOTE this widget has assumptions around limit being undefined to mean unlimited; but to reuse
            // the common getVisualExportLimit code, for the unlimited case use the value of -1 here
            props.limit = props.limit || -1;
            props.limit = RivalIQ.apps.Dashboard.widgets.TableWidget.prototype.getVisualExportLimit.call(me, props);

            return props;
        },

        allowPageBreaks: function () {
            const me = this;

            const limit = me.getProp('limit');
            return !_.isFinite(limit);
        }
    });


    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.FB_INSIGHTS_POSTS, FbInsightsPostsWidget);

    const LiInsightsPostsWidget = InsightsPostsWidget.extend({

        title: RivalIQ.strings.li_insights_posts_title,

        description: function () {
            const me = this;
            return (me.isFocus() ? RivalIQ.strings.li_insights_posts_info : RivalIQ.strings.li_insights_posts_mini_info);
        },

        postName: 'Post',

        postBarTypes: {
            reach: {
                className: 'organic',
                name: 'Reach'
            },
            clicks: {
                className: 'post-clicks',
                name: 'Update clicks'
            },
            engagement: {
                className: 'likes-comments-shares',
                name: 'Likes, Comments, Shares'
            }
        },

        getDefaultColumns: function (data) {
            const me = this;

            function getLIReachTooltip(post, aggregate) {
                return getMetricLabel('Reach', abbreviatedFormatter(aggregate));
            }

            function getLIEngagementTooltip(post, aggregate, concept) {
                return getMetricLabel(concept.name, abbreviatedFormatter(aggregate));
            }

            return [
                {
                    name: 'Published',
                    property: 'published_at',
                    sort: 'published_at',
                    cellClassName: 'published',
                    // NOTE: if you don't set a width on this column, you'll get odd export behavior. See #3532
                    className: 'post-published col-sm-1',
                    formatter: createPublished
                },
                {
                    name: 'Update',
                    value: createPost,
                    cellClassName: 'post',
                    className: 'post-content-header'
                },
                {
                    name: 'Impressions',
                    property: 'impressions',
                    sort: 'impressions',
                    cellClassName: 'bars reach',
                    formatter: createBars([
                        _.extend(me.postBarTypes.reach, {
                            property: 'impressions'
                        })
                    ], data, getLIReachTooltip, undefined, {
                        omitNullBars: true
                    })
                },
                {
                    name: 'Engagement',
                    property: 'insights_engagement',
                    sort: 'insights_engagement',
                    cellClassName: 'bars engagement',
                    formatter: createBars([
                        _.extend(me.postBarTypes.clicks, {
                            property: 'clicks'
                        }),
                        _.extend(me.postBarTypes.engagement, {
                            property: ['likes', 'comments', 'shares']
                        })
                    ], data, getLIEngagementTooltip, undefined, {
                        omitNullValues: true
                    })
                },
                {
                    name: 'Engagement Rate',
                    property: 'insights_engagement_rate',
                    sort: 'insights_engagement_rate',
                    cellClassName: 'engagement-rate',
                    formatter: createEngagementRate
                }
            ];
        },

        csvExportProps: function (props) {
            const me = this;

            const columns = RivalIQ.apps.Insights.data.getLinkedInInsightsPostMetrics().getColumns().toArray();
            const exportColumns = RivalIQ.apps.Insights.utils.getDefaultPostColumns().concat(columns);

            return _.defaults({
                type: 'li_insights_updates',
                exportColumns: prepareExportColumnsForCSV(exportColumns),
                companyId: me.getProp('companyId'),
                timePeriod: me.getProp('timePeriod')
            }, props);
        },

        getLegendValues: function () {
            const me = this;
            return [me.postBarTypes.reach, me.postBarTypes.clicks, me.postBarTypes.engagement];
        },

        processProps: function (props) {

            _.defaults(props, {
                sortOrder: -1,
                sort: 'insights_engagement',
                filter: null,
                // If columns were not passed in, construct them from rivaliq state
                columns: postDetailsByChannel(props.channel).getColumns().getActiveIds(),
                postName: 'Update'
            });

            if (!props.instanceId) {
                // only show 3 by default outside of details mode.
                _.defaults(props, {
                    limit: 3
                });
            }

            return props;
        },

        viewMorePath: function () {
            const me = this;
            return me.getPath({
                presenceId: me.getProp('presenceId')
            });
        },

        allowPageBreaks: function () {
            const me = this;

            const limit = me.getProp('limit');
            return !_.isFinite(limit);
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.LI_INSIGHTS_UPDATES, LiInsightsPostsWidget);

}, window.s, window.d3, window.moment);
